import { Map } from 'immutable'
import { createSelector } from 'reselect'

const getMinors = (state: Map<string, any>) => state?.get('minors')

export const getMinorsSessionUsages = createSelector(getMinors, (minors) => minors?.get('sessionUsage'))
